import React from 'react';

class GlobalErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error("Critical UI Crash Captured:", error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen bg-dark flex flex-col items-center justify-center p-8 text-center">
                    <div className="glass-card p-12 max-w-lg">
                        <h1 className="text-4xl font-bold font-display text-primary mb-4">Something went wrong</h1>
                        <p className="text-light-muted mb-8 italic">
                            "Even in a decentralized future, sometimes the signal gets lost."
                        </p>
                        <button
                            onClick={() => window.location.reload()}
                            className="btn-primary px-8 py-3"
                        >
                            Reload Experience
                        </button>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default GlobalErrorBoundary;
